/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { ITransparentUpgradeableProxy__factory } from "./ITransparentUpgradeableProxy__factory";
export { TransparentUpgradeableProxy__factory } from "./TransparentUpgradeableProxy__factory";
